import { render, staticRenderFns } from "./NewHeader.vue?vue&type=template&id=a205a64c&"
import script from "./NewHeader.vue?vue&type=script&lang=js&"
export * from "./NewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports